export const BLUESKY_APPVIEW_PROXY = 'did:web:api.bsky.app#bsky_appview';

export function blueskyAppViewHeaders(headers?: HeadersInit): Headers {
  const proxied = new Headers(headers);
  if (!proxied.has('atproto-proxy')) {
    proxied.set('atproto-proxy', BLUESKY_APPVIEW_PROXY);
  }
  return proxied;
}
